import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  List as ImmutableList,
  Map as ImmutableMap,
} from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Block from '../components/block'
import BlockHeading from '../components/block_heading'
import MediaAttachmentList from '../components/media_attachment_list'
import { expandMediaAttachmentsByAccountId } from '../actions/media_attachments'

class AccountGallery extends ImmutablePureComponent {
  
  handleOnClick = (mediaAttachment) => {
    const url = !!mediaAttachment ? mediaAttachment.get('status_url') : undefined
    if (url) this.props.history.push(url)
  }

  render() {
    const {
      ids,
      isFetched,
      mediaType,
      title,
      accountId,
    } = this.props

    if (!accountId) return null
    if ((!ids || ids.size === 0) && isFetched) return null

    return (
      <Block>
        <BlockHeading title={title} />
        <MediaAttachmentList
         id={accountId}
         type='account'
         params={{
          mediaType,
          source:'status',
         }}
         onClick={this.handleOnClick}
         onExpand={expandMediaAttachmentsByAccountId}
        />
      </Block>
    )
  }

}

const mapStateToProps = (state, { accountId, mediaType }) => {
  const block = state.getIn(['media_attachments', 'account', accountId, mediaType], ImmutableMap())
  const ids = block.getIn(['items'], ImmutableList())
  const isFetched = block.getIn(['isFetched'], false)
	
  return { ids, isFetched }
}

AccountGallery.propTypes = {
  accountId: PropTypes.string,
  ids: ImmutablePropTypes.list,
  mediaType: PropTypes.oneOf(['image', 'video']).isRequired,
  title: PropTypes.string,
  isFetched: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps)(AccountGallery))
